import { FC, ReactNode } from 'react'
import * as cn from 'classnames'
import * as styles from 'styles/atoms/charts/ChartHeader.css'

export type ChartHeaderItem = {
  label: string
  value: ReactNode
  secondaryValue?: ReactNode
  secondaryLabel?: string
}

export type ChartHeaderProps = {
  twoRows?: boolean
  title?: string
  secondaryTitle?: string
  member: ChartHeaderItem
  peers: ChartHeaderItem
  others: ChartHeaderItem
  hideYouValue?: boolean
  withComparison: boolean
  className?: string
}

// TODO resp; get group names from container
const ChartHeader: FC<ChartHeaderProps> = (props) => {

  const { title, member, peers, others, twoRows, secondaryTitle, hideYouValue, withComparison, className } = props

  const renderValue = (value?: ChartHeaderItem['value']) => value ? (
    <div className={ styles.itemValue }>{ value }</div>
  ) : null

  const memberSecondaryLabel = !hideYouValue && <div className={ styles.item }>{ member.secondaryLabel }</div>

  const memberSecondaryValue = !hideYouValue && (
    <div className={ cn(styles.item, styles.member) }>
      { renderValue(member.secondaryValue) }
    </div>
  )

  const memberLabel = !hideYouValue && (
    <div className={ cn(styles.item, styles.member, styles.label) }>
      { member.label }
    </div>
  )

  const memberValue = !hideYouValue && (
    <div className={ cn(styles.item, styles.member) }>
      { renderValue(member.value) }
    </div>
  )

  const secondaryLabels = peers.secondaryLabel && others.secondaryLabel ? (
    <div className={ styles.secondaryLabelsWrapper }>
      <div className={ styles.labelsRow }>
        { memberSecondaryLabel }
        <div className={ styles.item }>{ peers.secondaryLabel }</div>
        <div className={ styles.item }>{ others.secondaryLabel }</div>
      </div>
    </div>
  ) : null

  const secondaryValues = peers.secondaryValue && others.secondaryValue ? (
    <div className={ styles.secondaryValuesWrapper }>
      { secondaryTitle != null && (
        <div className={ styles.secondaryTitle }>{ secondaryTitle }</div>
      )}
      <div className={ styles.itemsRow }>
        { memberSecondaryValue }
        <div className={ cn(styles.item, styles.peers) }>
          { renderValue(peers.secondaryValue) }
        </div>
        <div className={ cn(styles.item, styles.others) }>
          { renderValue(others.secondaryValue) }
        </div>
      </div>
    </div>
  ) : null

  const rootClassName = cn(styles.header, {
    [styles.twoRows]: twoRows,
    [styles.hideOthers]: !withComparison,
  }, className)

  return (
    <div className={ rootClassName }>
      { title ? (
        <div className={ styles.title }>
          { title }
        </div>
      ) : null }
      <div className={ styles.labelsRow }>
        { memberLabel }
        <div className={ cn(styles.item, styles.peers) }>
          { peers.label }
        </div>
        <div className={ cn(styles.item, styles.others) }>
          { others.label }
        </div>
      </div>
      <div className={ styles.itemsRow }>
        { memberValue }
        <div className={ cn(styles.item, styles.peers) }>
          { renderValue(peers.value) }
        </div>
        <div className={ cn(styles.item, styles.others) }>
          { renderValue(others.value) }
        </div>
      </div>
      { secondaryValues }
      { secondaryLabels }
    </div>
  )
}

export default ChartHeader
